module.exports = __webpack_public_path__ + "static/mongodb-b0d215debb34bccaa704d13d412ab16c.svg";